import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function Plus(props: IconProps) {
  return (
    <IconSvg {...props}>
      <path d="M18 8a.75.75 0 01.75.75v8.5h8.5a.75.75 0 010 1.5h-8.5v8.5a.75.75 0 01-1.5 0v-8.5h-8.5a.75.75 0 010-1.5h8.5v-8.5A.75.75 0 0118 8z"></path>
    </IconSvg>
  );
}
